export const defaultUnpatchedConsole = Object.assign({}, console);
